<template>
  <div class="coach-rank">
    <div class="find-more" @click="bindSelectStore">
      <span v-if="curStoreData" class="store">
        <span class="iconfont icon-dingwei"></span>
        <span class="store-name">{{ curStoreData.store_name }}</span>
      </span>
      <span v-else>发现更多教练</span>
      <div class="line"></div>
      <div
        ><span class="change-store">切换门店</span
        ><span class="iconfont icon-you"></span
      ></div>
    </div>
    <div class="rank-flex">
      <div class="rank-scroll" :class="{ 'page-scorll-disabled': !scroll }">
        <div style="padding-bottom: 32px">
          <CoachRank
            :isMember="activityInfo.activity_crowd == 1"
            :data="computedCoachRanList"
            @dynamic="bindToDynamic"
          ></CoachRank>
          <div class="dynamic-btn" @click="bindDynamic"
            ><span>查看教练的暖心瞬间</span
            ><span class="iconfont icon-you"></span
          ></div>
          <img
            class="gray-logo"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/105e8b8098652ec924de3cec5ec06d35_wh=390_33.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 选择门店 -->
    <van-popup
      v-model="showSelectStoreToast"
      position="bottom"
      get-container="body"
    >
      <SelectStore
        :show="showSelectStoreToast"
        @close="bindCloseStore"
        @confirm="bindSelectConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import CoachRank from './coach-rank.vue'
import SelectStore from './select-store.vue'
export default {
  components: { CoachRank, SelectStore },
  props: {
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showSelectStoreToast: false
    }
  },
  created() {
    this.getData()
    if (this.activityData && this.activityData.store_id) {
      let data = {
        store_id: this.activityData.store_id,
        store_name: this.activityData.store_name
      }
      this.$store.commit('coachActivity2024/setCurStoreData', data)
    } else {
      this.$store.commit('coachActivity2024/setCurStoreData', null)
    }
  },
  computed: {
    computedCoachRanList() {
      return this.$store.state.coachActivity2024.coachRankData.coachRankList
    },
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    },
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    },
    curStoreData() {
      return this.$store.state.coachActivity2024.coachRankData.curStoreData
    }
  },
  methods: {
    bindToDynamic() {},
    async getData() {
      await this.$store.dispatch(
        'coachActivity2024/actionCoachRank',
        this.activityData && this.activityData.store_id
      )
    },
    async bindSelectConfirm(curStoreDta) {
      this.$store.commit('coachActivity2024/setCurStoreData', curStoreDta)
      this.bindCloseStore()
      await this.$store.dispatch(
        'coachActivity2024/actionCoachRank',
        curStoreDta.store_id
      )
    },
    bindCloseStore() {
      this.showSelectStoreToast = false
    },
    bindSelectStore() {
      this.showSelectStoreToast = true
    },
    bindDynamic() {
      this.$emit('dynamic')
    }
  }
}
</script>
<style lang="scss">
.van-popup {
  background-color: transparent;
  overflow-y: visible;
}
</style>
<style lang="scss" scoped>
.coach-rank {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  .find-more {
    padding: 5px 20px 0px;
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
    display: inline-flex;
    align-items: center;
    .store {
      display: flex;
      align-items: center;
    }
    .store-name {
      max-width: 230px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .iconfont {
      font-weight: normal;
      color: rgba(5, 11, 39, 0.3);
      margin-right: 3px;
    }
    .line {
      width: 1px;
      height: 11px;
      background-color: rgba(5, 11, 39, 0.5);
      margin: 0px 5px;
    }
    .change-store {
      font-weight: normal;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 17px;
    }
  }
  .rank-flex {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .rank-scroll {
      height: 100%;
      overflow-y: scroll;
    }
    .page-scorll-disabled {
      overflow-y: hidden;
    }
  }
  .dynamic-btn {
    width: 335px;
    height: 32px;
    background: #f7f7f7;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin: 0 auto;
    color: rgba(5, 11, 39, 0.7);
    line-height: 20px;
  }
  .gray-logo {
    margin: 30px auto 20px;
    width: 130px;
    height: 11px;
    object-fit: contain;
  }
}
</style>
